import Page from './Page';
import './page.scss';

export default Page;
